// extracted by mini-css-extract-plugin
export default {"landing":"style_landing__UBJas"};